/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_ErrorInputs */

const en_shared_error = /** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const nl_shared_error = /** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout`)
};

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const de_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const es_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const fr_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const it_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const pt_br2_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const pl_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const hu_shared_error = en_shared_error;

/** @type {(inputs: Shared_ErrorInputs) => LocalizedString} */
const ro_shared_error = en_shared_error;

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Shared_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_error = /** @type {((inputs?: Shared_ErrorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_ErrorInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_error(inputs)
	if (locale === "de") return de_shared_error(inputs)
	if (locale === "es") return es_shared_error(inputs)
	if (locale === "fr") return fr_shared_error(inputs)
	if (locale === "nl") return nl_shared_error(inputs)
	if (locale === "it") return it_shared_error(inputs)
	if (locale === "pt-BR") return pt_br2_shared_error(inputs)
	if (locale === "pl") return pl_shared_error(inputs)
	if (locale === "hu") return hu_shared_error(inputs)
	return ro_shared_error(inputs)
});
export { shared_error as "shared.error" }